// formats EIN to XX-XXXXXXX
function formatEin(ein) {
  // normalized string
  const sanitizedNumber = ein.replace(/[^\d]/g, '')
  const regExp = /(\d{2})(\d+)/
  return sanitizedNumber.replace(regExp, '$1-$2')
}

export default formatEin
